import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';

import {MoodLogCount} from '../models/mood-log-count.model';
import {MoodCategoryType} from '../utility/mood-categories.enum';
import {MoodTypes} from '../utility/moods.enum';

@Injectable()
export class MoodLogCountAdapter implements IAdapter<MoodLogCount> {
  adaptToModel(resp: MoodLogCount): MoodLogCount {
    switch (resp.id) {
      case MoodTypes.SAD:
        resp.categoryId = MoodCategoryType.LOW_ENERGY_UNPLEASANT;
        break;
      case MoodTypes.TIRED:
        resp.categoryId = MoodCategoryType.LOW_ENERGY_UNPLEASANT;
        break;
      case MoodTypes.WORRIED:
        resp.categoryId = MoodCategoryType.HIGH_ENERGY_UNPLEASANT;
        break;
      case MoodTypes.ANGRY:
        resp.categoryId = MoodCategoryType.HIGH_ENERGY_UNPLEASANT;
        break;
      case MoodTypes.HAPPY:
        resp.categoryId = MoodCategoryType.HIGH_ENERGY_PLEASANT;
        break;
      case MoodTypes.RELAXED:
        resp.categoryId = MoodCategoryType.LOW_ENERGY_PLEASANT;
    }
    resp.count = 0;
    return resp;
  }
  adaptFromModel(data: MoodLogCount): any {
    return data;
  }
}
